commons.constant('MULTILINGUAL_PROCEDURES', new Set([
    'aboveThresholdEU',
    'competitiveDialogueEU',
    'competitiveDialogueEU.stage2',
    'aboveThresholdUA.defense',
    'simple.defense',
    'esco',
    'closeFrameworkAgreementUA',
]));